export default {
  SET_USEROAUTH: 'SET_USEROAUTH',
  INIT_USEROAUTH: 'INIT_USEROAUTH',
  CLEAR_USEROAUTH: 'CLEAR_USEROAUTH',
  SET_USERINFO: 'SET_USERINFO',
  CLEAR_USERINFO: 'CLEAR_USERINFO',
  SET_CONFIG: 'SET_CONFIG',
  SET_SELLER_CONFIG: 'SET_SELLER_CONFIG',
  INIT_OPENID: 'INIT_OPENID',
  SET_OPENID: 'SET_OPENID',
  CLEAR_OPENID: 'CLEAR_OPENRID',
  INIT_OPERATION_STATUS: 'INIT_OPERATION_STATUS',
  SET_OPERATION_STATUS: 'SET_OPERATION_STATUS',
  DELETE_OPERATION_STATUS: 'DELETE_OPERATION_STATUS',
  CLEAR_OPERATION_STATUS: 'CLEAR_OPERATION_STATUS',
  SET_SHOPPINGCART: 'SET_SHOPPINGCART',
  ADD_SHOPPINGCART: 'ADD_SHOPPINGCART',
  REDUCE_SHOPPINGCART: 'REDUCE_SHOPPINGCART',
  UPDATE_SHOPPINGCAR: 'UPDATE_SHOPPINGCAR',
  CLEAR_SHOPPINGCART: 'CLEAR_SHOPPINGCART',
  UPDATE_SHOPPINGCART: 'UPDATE_SHOPPINGCART',
  REMOVE_SHOPPINGCART: 'REMOVE_SHOPPINGCART',
  SET_ORDER_PAYMETHOD: 'SET_ORDER_PAYMETHOD',
  INIT_ORDER_PAYMETHOD: 'INIT_ORDER_PAYMETHOD',
  CLEAR_ORDER_PAYMETHOD: 'CLEAR_ORDER_PAYMETHOD',
  SET_GET_WXCODE_STATUS: 'SET_GET_WXCODE_STATUS',
  INIT_GET_WXCODE_STATUS: 'INIT_GET_WXCODE_STATUS',
  SET_ORDERINFO: 'SET_ORDERINFO',
  INIT_ORDERINFO: 'INIT_ORDERINFO',
  CLEAR_ORDERINFO: 'CLEAR_ORDERINFO',
  SET_BUYER_SHOPID: 'SET_BUYER_SHOPID',
  INIT_BUYER_SHOPID: 'INIT_BUYER_SHOPID',
  CLEAR_BUYER_SHOPID: 'CLEAR_BUYER_SHOPID',
  INIT_SUPPLIER_SKU_MAP: 'INIT_SUPPLIER_SKU_MAP',
  SET_SUPPLIER_SKU_MAP: 'SET_SUPPLIER_SKU_MAP',
  UPDATE_SUPPLIER_SKU: 'UPDATE_SUPPLIER_SKU',
  CLEAR_SUPPLIER_SKU_CHECKED: 'CLEAR_SUPPLIER_SKU_CHECKED',
  CLEAR_SUPPLIER_SKU_MAP: 'CLEAR_SUPPLIER_SKU_MAP',
  SET_SELLER_CUSTOMID: 'SET_SELLER_CUSTOMID',
  INIT_SELLER_CUSTOMID: 'INIT_SELLER_CUSTOMID',
  CLEAR_SELLER_CUSTOMID: 'CLEAR_SELLER_CUSTOMID'
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/mutation-types.js